<template>
  <el-scrollbar>
    <div class="scrollbar-flex-content">
      <CTable>
        <CTableHead>
          <tr class="d-flex" :class="`d-from${info.part_item_id}`">
            <CTableHeaderCell :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'">
              <CButton
                class="btn-outline-primary text-light"
                v-if="!showChild"
                @click="showChild = !showChild"
              >
                <img src="@/assets/icons/arrow-blue.svg" alt="" />
              </CButton>
              <CButton
                class="btn-outline-primary text-light"
                v-else
                @click="showChild = !showChild"
              >
                <img
                  class="openImg"
                  src="@/assets/icons/arrow-blue.svg"
                  alt=""
                />
              </CButton>
            </CTableHeaderCell>
            <CTableHeaderCell
              v-for="(option, index) in info.extension_info.cols"
              :key="index"
              :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'"
              :class="showChild ? '' : 'd-none'"
            >
              {{ option.title }}
            </CTableHeaderCell>
            <CTableHeaderCell class="col-1"> </CTableHeaderCell>
          </tr>
        </CTableHead>
        <CTableBody :class="showChild ? 'd-block' : 'd-none'">
          <tr
            :class="`d-from${info.part_item_id}`"
            v-for="(row_title, index) in row_items"
            :key="index"
            class="d-flex"
          >
            <CTableHeaderCell :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'">
              
            </CTableHeaderCell>
            <CTableDataCell
            :style="info.extension_info.cols.length <= 5 ? 'flex:1' : 'width:200px'"
              v-for="option in info.extension_info.cols"
              :key="option.title"
            >
              <CFormTextarea
                v-if="option.type === $defines.Part_Item_From_Type_Text"
                placeholder="請填入文字"
                rows="3"
                style="resize: none;"
              />
              <CFormInput
                v-if="option.type === $defines.Part_Item_Date_Date_Number"
                type="number"
                placeholder="請填入數字"
                @change="ChangeNumber"
                oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
              />
              <CFormCheck
                v-if="
                  option.type === $defines.Part_Item_From_Type_True_Or_False
                "
                required
              />
            </CTableDataCell>
            <CTableDataCell class="col-1">
              <div
                class="remove-button"
                v-if="index > 0"
                @click="removeRowHandle(index)"
              >
                <img
                  src="@/assets/icons/delete.svg"
                  class="me-3"
                  alt="delete"
                />
              </div>
            </CTableDataCell>
          </tr>
          <div class="add-button" @click="moreRowHandle()">增加</div>
        </CTableBody>
      </CTable>
    </div>
  </el-scrollbar>
</template>

<script>
import { ref, onMounted } from '@vue/runtime-core'

export default {
  props: {
    options: {
      type: Object,
      default: () => {},
    },
    id: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['isOpen'],
  setup(props) {
    let row_items = ref([])
    row_items.value = [1]
    const showChild = ref(true)
    onMounted(() => {
      // const tr = document.querySelectorAll(`.d-from${props.info.part_item_id}`)
      // if (tr) {
      //   const trWidth = props.info.extension_info.cols.length * 250 + 'px'
      //   tr.forEach((e) => {
      //     e.style.width = trWidth
      //   })
      // }
    })
    const removeRowHandle = (index) => {
      const item = row_items.value.splice(index, 1)
      console.log([item, row_items.value])
    }

    const moreRowHandle = async () => {
      await row_items.value.push(row_items.value.length + '.')
      const tr = document.querySelectorAll(`.d-from${props.info.part_item_id}`)
      if (tr) {
        const trWidth = props.info.extension_info.cols.length * 250 + 'px'
        tr.forEach((e) => {
          e.style.width = trWidth
        })
      }
    }
    const ChangeNumber = ($event) => {
      if ($event?.targ$eventt?.value) {
        $event.target.value = `${Number($event.target.value)}`
      }
    };
    return {
      row_items,
      moreRowHandle,
      removeRowHandle,
      showChild,
      ChangeNumber
    }
  },
}
</script>
<style lang="scss" scoped>
.add-button {
  background: #177baf;
  color: #fff;
  width: 80px;
  margin: 10px 0;
  border-radius: 8px;
  padding: 5px 0;
  text-align: center;
  cursor: pointer;
  &:hover {
    background: #2e90c5;
  }
}
.remove-button {
  width: 20px;
  cursor: pointer;
}
.openImg {
  rotate: (180deg);
}
</style>
